import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import IPermissions from "./IPermissions";

function hasRulesToApprove(permissions: IPermissions, phase: TradePhaseEnum, status: TradeStatusEnum): boolean {
  function getRule(): boolean {
    switch (phase) {
      case TradePhaseEnum.SpecialProjectApproved:
        if (status === TradeStatusEnum.Aberto) {
          return permissions.canApproveSpecialProject;
        }
      default:
        return false;
    }
  }

  return getRule() || permissions.isMaster;
}

export default hasRulesToApprove;



// WEBPACK FOOTER //
// ./src/components/Refatoracao/RejectApproveTrade/ChangeTradePhaseRuleMap.ts